import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { Icons, Images } from "assets";
import React, { useEffect, useState } from "react";
import styles from "./style.module.scss";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { routeConstant } from "shared/routes/routesConstant";
import {
  blockRequests,
  blockUserService,
  unblockUserService,
} from "shared/services/projectHeadService";
import { block_status, user_roles } from "shared/utils/constants";
import BlockRequests from "shared/modals/blockRequest";
import Confirmation from "shared/modals/confirmation";
import { toastMessage } from "shared/components/toast";

function AdminRequests() {
  const navigate = useNavigate();
  const [allRequests, setAllRequests] = useState<any>([]);
  const [openBlockRequest, setOpenBlockRequest] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [openConfirm, setOpenConfirmation] = useState<boolean>(false);
  const [blockLoader, setBlockLoader] = useState<boolean>(false);
  const [action, setAction] = useState<{ label: string; type: string }>({
    label: "",
    type: "",
  });

  const getAllRequests = () => {
    blockRequests(3)
      .then(({ data }) => {
        setAllRequests(data?.data?.data);
      })
      .catch((err) => {
        console.log("data", err?.response?.data?.message);
      });
  };

  useEffect(() => {
    getAllRequests();
  }, []);

  const handleAction = (action: any, selectedItem: any) => {
    const service: any =
      selectedItem?.is_blocked === 1
        ? blockUserService
        : selectedItem?.is_blocked === 0
        ? unblockUserService
        : null;

    if (!service) {
      setOpenConfirmation(false);
      return;
    }

    setBlockLoader(true);
    service(selectedItem?.id)
      .then((data: any) => {
        getAllRequests();
        setBlockLoader(false);
        setOpenConfirmation(false);
        toastMessage("success", data?.message);
      })
      .catch((err: any) => {
        console.log("Error----", err);
        setBlockLoader(false);
        toastMessage("error", err?.response?.data?.message);
      });
  };

  return (
    <div className={styles.mainContainer}>
      <Box className={styles.topContainer}>
        <div className={styles.headingContainer}>
          <label className={styles.heading}>Admin Role Requests</label>
          <label className={styles.subHeading}>
            Here you can active or deactive account request added by admin
          </label>
        </div>
        <div
          className={styles.viewDetail}
          onClick={() => navigate(routeConstant.approveRequest.path)}
        >
          View All <Icons.ArrowPointLeft />
        </div>
      </Box>
      <TableContainer component={Paper} className={styles.tableContainer}>
        <Table>
          <TableHead className={styles.tableHead}>
            <TableRow>
              <TableCell sx={{ maxWidth: "100px" }}>Name</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Request </TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={styles.tableBody}>
            {allRequests?.map((item: any, index: any, arr: any) => {
              return (
                <TableRow
                  className={classNames(
                    index + 1 === arr.length && styles.lastCells
                  )}
                >
                  <TableCell className={styles.nameCell}>
                    <img
                      src={
                        item?.role === user_roles.parent
                          ? item?.parent?.profile_picture
                          : item?.role === user_roles.reader
                          ? item?.reader?.profile_picture
                          : item?.role === user_roles.author
                          ? item?.author?.profile_picture
                          : item?.role === user_roles.publisher
                          ? item?.publisher?.profile_picture
                          : item?.role === user_roles.school
                          ? item?.school?.profile_picture
                          : Images.UserPlaceholderImage
                      }
                      alt="profile_picture"
                      className={styles.profilepic}
                    />
                    <label>
                      {" "}
                      {item?.role === user_roles.parent
                        ? item?.parent?.full_name
                        : item?.role === user_roles.reader
                        ? item?.reader?.full_name
                        : item?.role === user_roles.author
                        ? item?.author?.full_name
                        : item?.role === user_roles.publisher
                        ? item?.publisher?.full_name
                        : item?.role === user_roles.school
                        ? item?.school?.school_name
                        : "---"}
                    </label>
                  </TableCell>
                  <TableCell className={styles.tableCell}>
                    {item?.role === user_roles.parent
                      ? "Parent"
                      : item?.role === user_roles.reader
                      ? "Kid"
                      : item?.role === user_roles.author
                      ? "Author"
                      : item?.role === user_roles.publisher
                      ? "Publisher"
                      : item?.role === user_roles.school
                      ? "School"
                      : "---"}
                  </TableCell>
                  <TableCell className={styles.tableCell}>
                    {item?.is_blocked === block_status.request_block
                      ? "Block"
                      : item?.is_blocked === block_status.request_unblock
                      ? "Unblock"
                      : ""}
                  </TableCell>
                  <TableCell>
                    <div className={styles.actionContainer}>
                      <Tooltip
                        componentsProps={{
                          tooltip: { className: "tooltip" },
                          arrow: { className: "arrow" },
                        }}
                        placement="top"
                        arrow
                        title="View"
                      >
                        <div
                          onClick={() => {
                            setSelectedItem(item);
                            setOpenBlockRequest(true);
                          }}
                        >
                          <Icons.EyeIcon />
                        </div>
                      </Tooltip>

                      <Tooltip
                        componentsProps={{
                          tooltip: { className: "tooltip" },
                          arrow: { className: "arrow" },
                        }}
                        placement="top"
                        arrow
                        title="Approve"
                      >
                        <div
                          onClick={() => {
                            setOpenConfirmation(true);
                            setSelectedItem(item);
                            setAction({
                              label:
                                "Are you sure, you want to approve this request?",
                              type: "approve",
                            });
                          }}
                        >
                          <Icons.CrossTickIcon />
                        </div>
                      </Tooltip>

                      <Tooltip
                        componentsProps={{
                          tooltip: { className: "tooltip" },
                          arrow: { className: "arrow" },
                        }}
                        placement="top"
                        arrow
                        title="Reject"
                      >
                        <div
                          onClick={() => {
                            setOpenConfirmation(true);
                            setSelectedItem(item);
                            setAction({
                              label:
                                "Are you sure, you want to reject this request?",
                              type: "reject",
                            });
                          }}
                        >
                          <Icons.CrossCircleIcon />
                        </div>
                      </Tooltip>
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <BlockRequests
        open={openBlockRequest}
        handleClose={() => {
          setOpenBlockRequest(false);
          setSelectedItem(null);
        }}
        selectedItem={selectedItem}
      />

      <Confirmation
        open={openConfirm}
        handleClose={() => {
          setAction({
            label: "",
            type: "",
          });
          setOpenConfirmation(false);
          setSelectedItem(null);
        }}
        handleClick={() => handleAction(action, selectedItem)}
        text={action.label}
        loader={blockLoader}
      />
    </div>
  );
}

export default AdminRequests;
